document.addEventListener('DOMContentLoaded', () => {
  const sidePanelTabs = document.querySelectorAll('.side-panel.product-information-drawer');

  sidePanelTabs.forEach((panel) => {
    const tabButtons = panel.querySelectorAll('.tab-list button');
    const tabContents = panel.querySelectorAll('.tab-content');

    tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent any default button behavior
        console.log('Tab button clicked:', button.textContent.trim());

        const parentTab = button.parentElement;
        const tabIndex = parentTab.dataset.tabIndex;
        console.log('Tab Index:', tabIndex);

        // Remove 'active' class from all tabs and contents
        tabButtons.forEach((btn) => btn.parentElement.classList.remove('active'));
        tabContents.forEach((content) => content.classList.remove('active'));

        // Update ARIA attributes for accessibility
        tabButtons.forEach((btn) => {
          const btnParent = btn.parentElement;
          if (btnParent === parentTab) {
            btnParent.setAttribute('aria-selected', 'true');
            btnParent.setAttribute('tabindex', '0');
          } else {
            btnParent.setAttribute('aria-selected', 'false');
            btnParent.setAttribute('tabindex', '-1');
          }
        });

        // Add 'active' class to the selected tab and corresponding content
        parentTab.classList.add('active');
        const contentToShow = panel.querySelector(`.tab-content[data-tab-content-index="${tabIndex}"]`);
        if (contentToShow) {
          contentToShow.classList.add('active');
          console.log('Displaying content for tab index:', tabIndex);
        } else {
          console.warn('No content found for tab index:', tabIndex);
        }
      });
    });
  });
});
